import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Home from './pages/Home';
import Services from './pages/Services';
import Gallery from './pages/Gallery';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Contact from './pages/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import { initScrollAnimations } from './utils/ScrollObserver';
import './App.css';
import { EmailTest } from './EmailTest';

// Component to handle scroll animations with route changes
const AnimationHandler = () => {
  const location = useLocation();
  
  useEffect(() => {
    // Initialize scroll animations when component mounts and route changes
    const observer = initScrollAnimations();
    
    // Cleanup observer on unmount
    return () => {
      if (observer) {
        observer.disconnect();
      }
    };
  }, [location]); // Re-run when route changes
  
  return null;
};

// Component to handle scrolling to hash elements
const ScrollToHashElement = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      // Give the DOM time to render before scrolling
      setTimeout(() => {
        const element = document.getElementById(location.hash.substring(1));
        if (element) {
          window.scrollTo({
            top: element.offsetTop - 100, // Offset for header
            behavior: 'smooth'
          });
        }
      }, 100);
    }
  }, [location]);

  return null;
};

// Component to scroll to top on navigation
const ScrollToTop = () => {
  const { pathname } = useLocation();
  
  useEffect(() => {
    // Scroll to top when pathname changes (route navigation)
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
};

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <Header />
          <AnimationHandler />
          <ScrollToHashElement />
          <ScrollToTop />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:id" element={<BlogPost />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-service" element={<TermsOfService />} />
              <Route path="/email-test" element={<EmailTest />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
